module.exports = __webpack_public_path__ + "static/media/ticket-schedule.34936a05.svg";